<i18n locale="en">
{
  "actions": {
    "create": "Create"
  },
  "messages": {
    "generateEmailToContinue": "Generate an email to continue"
  }
}
</i18n>

<template>
  <div>
    <OwnPopover
      v-if="!currentResource"
      trigger-type="hover"
      :content-width="210"
      align-y="bottom"
      align-x="left"
      :slide="['x']"
    >
      <template #trigger="{ on }">
        <OwnButton
          class="w-full"
          data-testid="create-campaign-button"
          :text="t('actions.create')"
          variant="primary"
          :disabled="!currentResource"
          v-on="on"
          @click="onCreateClick"
        >
          <template #icon-right>
            <PhArrowCircleRight size="24" />
          </template>
        </OwnButton>
      </template>
      <template #content>
        <OwnCard
          class="new-campaign-right-actions new-campaign-right-actions__content"
          control
        >
          <OwnType
            :text="t('messages.generateEmailToContinue')"
            variant="paragraph-small"
            color="secondary"
          />
        </OwnCard>
      </template>
    </OwnPopover>

    <OwnButton
      v-else
      class="w-full"
      data-testid="create-campaign-button"
      :text="t('actions.create')"
      variant="primary"
      :disabled="!currentResource"
      @click="onCreateClick"
    >
      <template #icon-right>
        <PhArrowCircleRight size="24" />
      </template>
    </OwnButton>

    <NewCampaignErrorDialog
      v-if="showErrorDialog"
      @close="showErrorDialog = false"
    />
  </div>
</template>

<script>
import { PhArrowCircleRight } from '@phosphor-icons/vue'
import { useI18n } from 'vue-i18n'
import { mapGetters } from 'vuex'

import { OwnButton } from '@/ui/OwnButton'
import { OwnCard } from '@/ui/OwnCard'
import { OwnPopover } from '@/ui/OwnPopover'
import { OwnType } from '@/ui/OwnType'

import NewCampaignErrorDialog from './NewCampaignErrorDialog.vue'

export default {
  name: 'NewCampaignRightActions',
  components: {
    NewCampaignErrorDialog,
    OwnButton,
    OwnCard,
    OwnPopover,
    OwnType,
    PhArrowCircleRight,
  },
  emits: ['create'],
  data() {
    return {
      showErrorDialog: false,
    }
  },
  setup() {
    const { t } = useI18n()

    return { t }
  },
  computed: {
    ...mapGetters({
      currentResource: 'emailBuilder/currentResource',
    }),
  },
  methods: {
    onCreateClick() {
      const { currentResource } = this

      if (currentResource) {
        this.$emit('create')
      } else {
        this.showErrorDialog = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.new-campaign-right-actions {
  &__content {
    padding: 8px;
    width: fit-content;
    white-space: nowrap;
  }
}
</style>
